import appConfig from '+/appConfig';
import { createPushSubscription, testPushSubscription } from '+/utils/apiCalls';
import { addUserPushSubscription } from '+/actions';

import store from './store';

const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map(char => char.charCodeAt(0)));
};

const getSubscription = async () => {
  const { publicVapid } = appConfig;
  await navigator.serviceWorker.register('/push-service-worker.js', { scope: '/' });
  const { pushManager } = await navigator.serviceWorker.ready;
  const subscriptionOptions = {
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicVapid),
  };
  return pushManager.subscribe(subscriptionOptions);
};

export const subscribe = async () => {
  if (!navigator.serviceWorker) return false;
  const subscription = await getSubscription();
  const { pushSubscriptions } = store.getState();
  if (pushSubscriptions.user.includesEnabledEndpoint(subscription.endpoint)) return true;
  const responseData = await createPushSubscription(subscription);
  store.dispatch(addUserPushSubscription(responseData));
  testPushSubscription({ endpoint: subscription.endpoint });
  return true;
};
